export default "__VITE_ASSET__BxKFTpcS__"